import './Theme.Table.Simple.2.scss';
export default 'ThemeTableSimple2';
